
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'avy-rolldown',
  templateUrl: './rolldown.component.html',
  styleUrls: ['./rolldown.component.css']
})
export class RolldownComponent implements OnInit {

@Input() title= '';
isOpen = false;
  constructor() { }

  ngOnInit() {
  }

rollUp(){
  this.isOpen = false;
}

}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/rolldown/rolldown/rolldown.component.ts